import { render, staticRenderFns } from "./LeshanNavBar.vue?vue&type=template&id=36483b7a&scoped=true&"
import script from "./LeshanNavBar.vue?vue&type=script&lang=js&"
export * from "./LeshanNavBar.vue?vue&type=script&lang=js&"
import style0 from "./LeshanNavBar.vue?vue&type=style&index=0&id=36483b7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36483b7a",
  null
  
)

export default component.exports